/*********************************************************************
Alexander Self
Card Component
Original Author: Brandon Morelli
https://codeburst.io/build-a-minimalist-html-card-in-just-53-lines-of-code-with-flexbox-b40801927eb5
*********************************************************************/
import React from 'react';

const Card = ({ header, width, icon, desc, color, borderColor, headerColor, onclick, _class, id, child }) => {
  const card = {
    width: width,
    border: `1px solid ${borderColor}`,
    borderRadius: "4px", /* Slightly Curve edges */
    overflow: "hidden", /* Fixes the corners */
    display: "flex",
    flexDirection: "column"
  };
  const cardHeader = {
    color: `${color}`,
    textAlign: "center",
    fontSize: "11px",
    fontWeight: 600,
    borderBottom: `1px solid ${borderColor}`,
    backgroundColor: `${headerColor}`,
    padding: "5px 10px"
  };
  const cardMain = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px 0"
  };
  const cardIcon = {
    fontSize: "36px",
    color: `${color}`,
    marginBottom: "5px"
  };
  const cardDescription = {
    color: `${color}`,
    fontSize: "12px",
    textAlign: "center"
  };

  return (
    <div style={card} onClick={onclick} className="waves-effect" data-target={id}>
      <div style={cardHeader}>{ header }</div>
      <div style={cardMain}>
        <i style={cardIcon} className={`material-icons`}>{ icon }</i>
        <div style={cardDescription}>
          { desc }
          <div className={_class}>
            { child }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;


/* END */



// WEBPACK FOOTER //
// ./src/components/card.js